import script from "./PanelizationPropositionByType.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelizationPropositionByType.vue?vue&type=script&setup=true&lang=js"

import "./PanelizationPropositionByType.vue?vue&type=style&index=0&id=5cfc8728&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfc8728"]])

export default __exports__